class subCollection extends HTMLElement {
    constructor() {
        super();

        const self = this;

        const collectionId = document.querySelector(".collection-content").getAttribute('data-section-id');
        const bannerId = document.querySelector(".js-collection-banner").getAttribute('data-section-id');

        this.sections = {
            banner: {
                sectionId: bannerId,
                nodeId: "collectionBanner"
            },
            main: {
                sectionId: collectionId,
                nodeId: "CollectionAjaxContent"
            }
        };

        this.ajaxCollectionEl = document.querySelector(`#${this.sections.main.nodeId}`);
        this.collectionBanner = document.querySelector(`#${this.sections.banner.nodeId}`);
        this.subCollectionItems = this.querySelectorAll("[js-sub-collection-item]");
        this.slider = this.querySelector("[js-sub-collection-slider]");
        this.subCollectionDropdown = this.querySelector("[js-sub-collection-dropdown]");
        this.dropDownBtn = this.querySelector("[js-dropdown-btn]");
        this.dropDownLabel = this.querySelector("[js-dropdown-label]");

        this.initSlider();

        this.subCollectionItems.forEach( item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                const collectionHandle = this.dataset.collectionHandle;
                const collectionTitle = this.dataset.collectionTitle;
                const collectionTitleDisplay = this.dataset.collectionDisplayTitle;
              
                self.updateLabel(collectionTitleDisplay)
                self.initAjaxCollection(collectionHandle, this);
                self.close()
            })
        });

        this.dropDownBtn.addEventListener("click", () => {
            this.toggleDropdown();
        });

        document.addEventListener("click", (event) => {
            if(!this.contains(event.target)) {
                this.close()
            }
        });
    };
    

    initSlider() {
        new Swiper (this.slider, {
            loop: false,
            grabCursor: false,
            spaceBetween: 16,
            slidesPerGroup: 2,
            slidesPerView: "auto",
            watchSlidesProgress: true,
            draggable:!0,
            autoHeight:!1,
            watchOverflow:!0,
            threshold:10,
            mousewheel:{
              forceToAxis:!0
            },
            observer: true,
            observeParents: true,
            freeMode: true,
            breakpoints: {
                767: {
                    slidesPerView: 'auto',
                    spaceBetween: 16
                },
                0: {
                    slidesPerView: 'auto',
                    spaceBetween: 8
                }
            }
        });
    };

    toggleDropdown() {
        this.subCollectionDropdown.classList.toggle("is-open");
    };

    close() {
        this.subCollectionDropdown.classList.remove("is-open");
    };

    updateLabel(title) {
        this.dropDownLabel.innerText = title;
    };

    initAjaxCollection(handle, targetEl) {
        this.changeActiveState(targetEl);
        this.updateHistoryState(handle);
        this.renderCollectionBanner(handle);
        this.renderAjaxCollection(handle);
    };

    changeActiveState(targetEl) {
        this.subCollectionItems.forEach( item => item.classList.remove("active"));
        targetEl.classList.add('active');
    };

    updateHistoryState(handle) {
        var newurl = `${window.location.protocol}//${window.location.host}/collections/${handle}?sort_by=manual`;
        window.history.replaceState({path: newurl}, '', newurl);
    };

    renderCollectionBanner(handle) {
        const self = this;
        const url = `/collections/${handle}?section_id=${this.sections.banner.sectionId}`;

        this.collectionBanner.classList.add("loading");

        fetch(url).then(function(response) {
            return response.text();
        }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            self.collectionBanner.innerHTML = doc.querySelector(`#${self.sections.banner.nodeId}`).innerHTML;
            self.collectionBanner.classList.remove("loading");
        });
    };

    renderAjaxCollection(handle) {
        const self = this;
        const url = `/collections/${handle}?section_id=${this.sections.main.sectionId}&sort_by=manual`;
        document.dispatchEvent(new CustomEvent('startLoading:init'));

        fetch(url).then(function(response) {
            return response.text();
        }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            self.ajaxCollectionEl.innerHTML = doc.querySelector(`#${self.sections.main.nodeId}`).innerHTML;

            document.dispatchEvent(new CustomEvent('atc-init'));
            document.dispatchEvent(new CustomEvent('ajaxAddToCart:init'));
            document.dispatchEvent(new CustomEvent("product-media-slider:init"));
            document.dispatchEvent(new CustomEvent('layout-btns:init'));
            document.dispatchEvent(new CustomEvent('collection-grid-item:init'));
            document.dispatchEvent(new CustomEvent('collection:init'));
            document.dispatchEvent(new CustomEvent('ajax-pagination:init'));
            
            theme.collapsibles.init();
        });
    }
}
  
customElements.define('sub-collection', subCollection);
